import type { SearchApiResponse, SearchSeoApiResponse } from '../api/rest/types';

export function extractTrackingInformation(
  apiResponse: SearchApiResponse,
  seoResponse?: SearchSeoApiResponse,
) {
  const { searchId, pageTitle, pageNoDisplay, displayType } = apiResponse.searchresult.information;
  const { majorMkz, products, count, selectedFilters, criteo } = apiResponse.searchresult.result;
  const { sortType, query } = apiResponse.searchresult.request;
  const { title } = (seoResponse as SearchSeoApiResponse) ?? {};

  const resultFallbackType =
    'alternativeSearchSystem' in apiResponse.searchresult.information
      ? apiResponse.searchresult.information.alternativeSearchSystem
      : undefined;
  const alternativeQuery =
    'alternativeQuery' in apiResponse.searchresult.information
      ? apiResponse.searchresult.information.alternativeQuery
      : undefined;

  // TODO i18n, currently only german
  const categoryPath = apiResponse.searchresult.result?.navigation?.breadCrumb?.map((item) => ({
    id: item.id,
    name: item.name === 'Startseite' ? 'storefront' : item.name,
  }));

  const criteoProducts = criteo?.criteoProducts;
  const { landmarkUrls } = apiResponse.searchresult.information ?? {};

  return {
    searchId,
    marketcode: majorMkz,
    categoryPath,
    landmarkUrls,
    pageTitle: title ?? pageTitle,
    products,
    pageNoDisplay,
    count,
    sortType,
    selectedFilters,
    displayType,
    criteoProducts,
    alternativeQuery,
    resultFallbackType,
    query,
  };
}
